import React from 'react';
import type { FranchiseData } from '../../sourcing/source-nodes/sources/franchises';

const getMarkup = (parsedTag: string|number): string => `
            <script async src="https://www.googletagmanager.com/gtag/js?id=${parsedTag}"></script>
            <script>
               window.dataLayer = window.dataLayer || [];
               function gtag(){dataLayer.push(arguments);} 
               gtag('js', new Date()); gtag('config', '${parsedTag}');
               gtag('event', 'conversion', {
                  'send_to': '${parsedTag}',
                  'value': 1.0,
                  'currency': 'USD',
               });
            </script>
        `;

const MicrositeGtagProvider = ({ children, data }: { children: React.ReactNode, data: Partial<{ franchise?: FranchiseData }> }): JSX.Element => {
    const adwordsTag = data?.franchise?.googleAdsTag;
    const elRef = React.useRef<HTMLDivElement|null>(null);

    React.useEffect(() => {
        if (adwordsTag && elRef.current) {
            if ('innerHTML' in elRef.current) {
                const range = document.createRange();
                range.selectNode(elRef.current);
                const documentFragment = range.createContextualFragment(getMarkup(adwordsTag));
                elRef.current.innerHTML = '';
                elRef.current.append(documentFragment);
            }
        }
    }, [adwordsTag]);

    if (adwordsTag) {
        return (
            <>
                <span
                    ref={elRef}
                    /* eslint-disable-next-line react/no-danger */
                    dangerouslySetInnerHTML={{ __html: getMarkup(adwordsTag) || '' }}
                />
                {children}
            </>
        );
    }

    return (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        <>
            {children}
        </>
    );
};

export default MicrositeGtagProvider;
